class ImageGallery extends Component {
    constructor(el) {
        super(el);
        this.swiperEl = this.$find('[data-swiper]');
        this.swiper = null;
        this.swiperEl && this.constructSwiper();
    }

    constructSwiper() {
        this.swiper = new Swiper(this.swiperEl, {
            watchOverflow: true,
            loop: false,
            autoplay: {
                delay: 4000,
            },
            pagination: {
                el: '[data-gallery-pagination]',
                clickable: true
            },
            navigation: {
                nextEl: '.ImageGallery-next',
                prevEl: '.ImageGallery-prev',
            },
            slidesPerView: "auto",
            centeredSlides: true,
            spaceBetween: 40
        });
    }
}